import { useLiveData, useService } from '@toeverything/infra';
import { useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';

import { WorkbenchService } from '../../workbench/services/workbench';
import { AIOperatorPresenceOverlay } from '../app-operator/ai-operator-presence-overlay';
import {
  assistantStays,
  getAssistantPresenceStore,
  useAssistantPresence,
} from './assistant-presence-store';
import { WorkspaceViewContextService } from './workspace-view-context';

/** Active main view owns navigation presence; its coordinates are browser viewport pixels. */
export function WorkspaceNavigationPresence({ viewId }: { viewId: string }) {
  const service = useService(WorkspaceViewContextService);
  const workbench = useService(WorkbenchService).workbench;
  const activeView = useLiveData(workbench.activeView$);
  const store =
    activeView.id === viewId
      ? service.getNavigationPresentation({
          workspaceId: service.workspaceId,
          viewId,
        })
      : null;
  useEffect(() => () => store?.clear(), [store]);
  const assistant = useMemo(
    () => getAssistantPresenceStore(service.workspaceId),
    [service.workspaceId]
  );
  const presence = useAssistantPresence(assistant);
  const { working } = presence;
  const stays = assistantStays(presence);
  useEffect(() => store?.setLingering(stays), [store, stays]);
  return store && typeof document !== 'undefined'
    ? createPortal(
        <AIOperatorPresenceOverlay
          store={store}
          coordinateSpace="viewport"
          onStop={working ? () => assistant.stop() : undefined}
        />,
        document.body
      )
    : null;
}
